import { render, staticRenderFns } from "./PasswordResetComponent.vue?vue&type=template&id=a9deb86c&scoped=true&"
import script from "./PasswordResetComponent.vue?vue&type=script&lang=js&"
export * from "./PasswordResetComponent.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetComponent.vue?vue&type=style&index=0&id=a9deb86c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9deb86c",
  null
  
)

export default component.exports